import React from "react";
import { UseFormRegister } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";

type Inputs = any;
interface Props {
  register: UseFormRegister<Inputs>;
  errors: any;
  name: string;
  label: string;
  options: string[];
  translateId?: string;
  disabled?: boolean;
  printEnabled?: boolean;
}

const SelectElement: React.FC<Props> = ({
  name,
  register,
  errors,
  label,
  options,
  translateId,
  disabled,
  printEnabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid md:grid-cols-2 grid-cols-1 w-full gap-[5px] md:gap-0">
      <label
        htmlFor={`${name}`}
        className="flex flex-wrap font-normal text-xl text-[#1E408E] pr-9"
      >
        <Trans t={t}>{label}</Trans>
      </label>
      <div className="grid pr-10">
        <div className="flex flex-row justify-evenly gap-x-4">
          <select
            {...register(`${name}`)}
            id={`${name}`}
            className="w-full h-12 border border-[#8692A6] rounded p-2"
            defaultValue=""
            disabled={disabled}
          >
            <option value="" disabled hidden>
              {t("Select")}
            </option>
            {options?.map((item, index) => (
              <option key={index} value={`${item}`}>
                {t(`${item}`)}
              </option>
            ))}
          </select>
          {printEnabled && (
            <input
              type="checkbox"
              {...register(`print${name}`)}
              defaultChecked
              id={`${name}`}
            />
          )}
        </div>
        <p className="text-red-500 text-xs">{errors[name]?.message}</p>
      </div>
    </div>
  );
};

export default SelectElement;
